import { render } from "./main-collection.vue?vue&type=template&id=5e85dc3e"
import script from "./main-collection.vue?vue&type=script&lang=js"
export * from "./main-collection.vue?vue&type=script&lang=js"

import "./main-collection.vue?vue&type=style&index=0&id=5e85dc3e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__